export const DEFAULT_TOASTER_TIMEOUT = 5000;
export const DEFAULT_ACTION_LABEL = "Action";
